import React, { useState } from "react";
import {
  showError,
  showSuccess,
} from "../../../../../../../../utils/showMessage.js";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Images from "../../../../../../../../utils/images.js";
import CrossButton from "../../../../../../../common/ButtonSpinner/CrossButton.js";
import GeneralButton from "../../../../../../../common/SaveButton/GeneralButton.js";
import CustomModal from "../../../../../../../common/CustomModal/CustomModal.js";
import "react-toastify/dist/ReactToastify.css";
import { dropTable } from "../../../../../../../../api/database_gui.js";

const TableDropPopup = ({
  visible,
  onClose,
  onSave,
  databaseName,
  tableName,
  appId,
  systemUserId,
  loading,
  setLoading,
  setTableDrop,
  databaseInfo,
}) => {
  const handleConfirm = async () => {
    try {
      const response = await dropTable(
        appId,
        systemUserId,
        databaseName,
        tableName
      );

      if (response.error) {
        let errorMessage = null;
        
        if (typeof response.error === 'string') {
          errorMessage = response.error;
        } else if (response.error.message) {
          if (Array.isArray(response.error.message)) {
            errorMessage = response.error.message.join(', ');
          } else {
            errorMessage = response.error.message;
          }
        } else if (Array.isArray(response.error)) {
          errorMessage = response.error.join(', ');
        } else if (typeof response.error === 'object') {
          errorMessage = JSON.stringify(response.error);
        }
        
        if (errorMessage) {
          showError(errorMessage);
        }
      } else {
        onSave();
        const successMessage = response.message;
        if (successMessage) {
          showSuccess(successMessage);
        }
        onClose();
      }
    } catch (error) {
      const errorMessage = error?.response?.data?.message || 
                          error?.response?.data?.errors?.message || 
                          error?.message;
      if (errorMessage) {
        showError(Array.isArray(errorMessage) ? errorMessage.join(', ') : errorMessage);
      }
    }
  };

  return (
    <CustomModal 
      open={visible} 
      handleClose={onClose}
      width="35%"
    >
      <div>
        <div className="d-flex justify-content-between align-items-start mb-3">
          <div>
            <div className="d-flex align-items-center mb-1">
              {databaseInfo === "MySQL" && (
                <img src={Images.mysql} alt="MySQL" width="24" height="24" className="me-2" />
              )}
              {databaseInfo === "PostgreSQL" && (
                <img src={Images.pssql} alt="PostgreSQL" width="24" height="24" className="me-2" />
              )}
              {databaseInfo === "MSSQL" && (
                <img src={Images.mssql} alt="MSSQL" width="24" height="24" className="me-2" />
              )}
              <h3 className="border-0 customize-column-name mb-0">
                Drop Table
              </h3>
            </div>
            <p className="text-muted mb-0 fs-14px">
              Permanently remove a table and all its data from the database.
            </p>
          </div>
          <CrossButton onClick={onClose} />
        </div>

        <div className="mb-4">
          <div className="alert alert-warning py-3">
            <div className="d-flex align-items-start">
              <img
                src={Images.InfoIcon}
                alt="warning"
                width="16"
                height="16"
                className="me-2 mt-1"
              />
              <div>
                <strong>Warning:</strong> Are you sure you want to drop the table{" "}
                <code className="bg-light px-2 py-1 rounded">{tableName}</code> from database{" "}
                <code className="bg-light px-2 py-1 rounded">{databaseName}</code>?
              </div>
            </div>
          </div>
          <small className="text-muted">
            This action cannot be undone and will permanently delete all data in the table.
          </small>
        </div>

        <Row className="pt-4 mb-3 justify-content-end">
          <Col sm="auto">
            <GeneralButton
              onClickEvent={onClose}
              className="me-1"
              value="Cancel"
              color="#505050"
              variant="outlined"
              size="large"
            />
          </Col>
          <Col sm="auto" className="me-sm-2 p-0">
            {loading ? (
              <GeneralButton
                onClickEvent={handleConfirm}
                variant="contained"
                disabled={true}
                className="me-1"
                value={
                  <img src={Images.Loader} width="26px" height="26px" />
                }
                size="large"
              />
            ) : (
              <GeneralButton
                onClickEvent={handleConfirm}
                className="me-1"
                value="Drop"
                variant="contained"
                size="large"
              />
            )}
          </Col>
        </Row>
      </div>
    </CustomModal>
  );
};

export default TableDropPopup;
